const isProd = process.env.NODE_ENV === 'production';

export const cf = (path: string) => {
  if (!path) return '';

  const publicPath = `https://d3nh4y40u6qzkw.cloudfront.net`;
  const _path = path.startsWith('/') ? path :`/${path}`
  return `${publicPath}${_path}`;
};
